// Cobrança via Pix: renderiza o card quando a mensagem traz o payload
// estruturado (content_attributes.pix, ex.: botão PIX enviado pela uazapi — em
// qualquer caixa) ou, em caixas AstraCall, pelo marcador 💠 no texto.
export const isPixMessage = ({
  isTextType,
  content,
  contentAttributes,
  isAstraCallInbox,
}) => {
  if (!isTextType || typeof content !== 'string') return false;
  if (!content.includes('💠')) return false;
  return Boolean(contentAttributes?.pix) || Boolean(isAstraCallInbox);
};
